import React, { useState } from 'react';
import styled from 'styled-components';

const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.75);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
  animation: fadeIn 0.3s ease;

  @keyframes fadeIn {
    from { opacity: 0; }
    to { opacity: 1; }
  }
`;

const ModalContent = styled.div`
  background: white;
  padding: 20px;
  border-radius: 20px;
  width: 90%;
  max-width: 400px;
  animation: slideUp 0.3s ease;
  overflow: hidden;

  @keyframes slideUp {
    from { transform: translateY(50px); opacity: 0; }
    to { transform: translateY(0); opacity: 1; }
  }
`;

const Title = styled.h2`
  font-size: 24px;
  font-weight: 600;
  color: #333;
  margin: 0 0 8px 0;
  text-align: center;
  font-family: var(--font-heading);
`;

const Subtitle = styled.p`
  font-size: 14px;
  color: #666;
  margin: 0 0 20px 0;
  text-align: center;
  font-family: var(--font-body);
`;

const StoresList = styled.div`
  max-height: 60vh;
  overflow-y: auto;
  margin: 0 -20px;
  padding: 0 20px;
`;

const StoreCard = styled.div`
  padding: 15px;
  margin: 8px 0;
  border-radius: 12px;
  border: 2px solid ${props => props.selected ? 'var(--primary-color)' : 'transparent'};
  background: ${props => props.selected ? 'color-mix(in srgb, var(--primary-color) 10%, white)' : '#f8f8f8'};
  display: flex;
  align-items: center;
  justify-content: space-between;
  transition: all 0.2s ease;
  cursor: pointer;

  &:active {
    transform: scale(0.98);
  }
`;

const StoreName = styled.span`
  font-size: 16px;
  font-weight: 500;
`;

const CheckIcon = styled.span`
  color: var(--primary-color);
  opacity: ${props => props.visible ? 1 : 0};
  transition: opacity 0.2s ease;
`;

const Button = styled.button`
  width: 100%;
  padding: 16px;
  background: var(--primary-color);
  color: white;
  border: none;
  border-radius: 12px;
  font-size: 16px;
  font-weight: 600;
  margin-top: 20px;
  opacity: ${props => props.disabled ? 0.5 : 1};
  transition: all 0.2s ease;
  cursor: ${props => props.disabled ? 'default' : 'pointer'};

  &:active {
    transform: ${props => props.disabled ? 'none' : 'scale(0.98)'};
  }
`;

const stores = [
  { id: 'marsac', name: 'VAPO SMOKE TODAY MARSAC' },
  { id: 'boulazac', name: 'VAPO SMOKE TODAY BOULAZAC' },
  { id: 'perigueux', name: 'VAPO SMOKE TODAY PERIGUEUX' },
  { id: 'st-astier', name: 'VAPO SMOKE TODAY ST-ASTIER' },
  { id: 'nontron', name: 'VAPO SMOKE TODAY NONTRON' },
  { id: 'terrasson', name: 'VAPO SMOKE TODAY TERRASSON' },
  { id: 'saint-junien', name: 'VAPO SMOKE TODAY SAINT-JUNIEN' },
  { id: 'bergerac-vallade', name: 'VAPO SMOKE TODAY BERGERAC VALLADE' },
  { id: 'bergerac-centre', name: 'VAPO SMOKE TODAY BERGERAC CENTRE VILLE' },
  { id: 'sarlat', name: 'VAPO SMOKE TODAY SARLAT' },
  { id: 'le-bugue', name: 'VAPO SMOKE TODAY LE BUGUE' }
];

const StoreSelectionModal = ({ onStoreSelect }) => {
  const [selectedStore, setSelectedStore] = useState(null);

  const handleStoreClick = (store) => {
    setSelectedStore(store);
  };

  const handleSubmit = () => {
    if (selectedStore) {
      onStoreSelect(selectedStore);
    }
  };

  return (
    <ModalOverlay>
      <ModalContent>
        <Title>Choisissez votre boutique</Title>
        <Subtitle>Cette sélection est définitive</Subtitle>
        
        <StoresList>
          {stores.map(store => (
            <StoreCard
              key={store.id}
              selected={selectedStore?.id === store.id}
              onClick={() => handleStoreClick(store)}
            >
              <StoreName>{store.name}</StoreName>
              <CheckIcon visible={selectedStore?.id === store.id}>✓</CheckIcon>
            </StoreCard>
          ))}
        </StoresList>

        <Button 
          onClick={handleSubmit} 
          disabled={!selectedStore}
        >
          Confirmer
        </Button>
      </ModalContent>
    </ModalOverlay>
  );
};

export default StoreSelectionModal; 